<div class="page">
  <ngx-loading [show]="showSpinner"></ngx-loading>

  <div class="page-content">
    <div class="table-top">
      <div class="section-header">Firmas Pendientes</div>
    </div>

    <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

    <div *ngIf="!showSpinner && items.length === 0 && !errorMessage" class="alert alert-info mt-3">
      No hay constancias con firma pendiente que superen el umbral configurado.
    </div>

    <table class="table table-striped table-bordered mt-3" *ngIf="items.length > 0">
      <thead>
        <tr class="table-names">
          <th>ID Constancia</th>
          <th>Tipo</th>
          <th>Firmante(s)</th>
          <th>Email</th>
          <th>Tiempo pendiente</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of items">
          <tr *ngFor="let user of item.usersWithPendingSignature; let first = first">
            <td *ngIf="first" [attr.rowspan]="item.usersWithPendingSignature.length">
              {{ item.documentProcessId }}
            </td>
            <td *ngIf="first" [attr.rowspan]="item.usersWithPendingSignature.length">
              {{ item.constancyType }}
            </td>
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>
              <span class="badge badge-warning">{{ formatMinutes(user.minutesSinceRequest) }}</span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center mt-2" *ngIf="totalPages > 1">
      <small class="text-muted">{{ totalCount }} constancia(s) — página {{ currentPage }} de {{ totalPages }}</small>
      <div>
        <button class="btn btn-sm btn-outline-secondary mr-1" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
          <i class="fa fa-chevron-left"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
